/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const Vue = require("vue");

const city = Vue.component("city",{
	template: `
		<div class="city-stage">
			 <slot></slot>
		</div>
	`
})

const province = Vue.component("province",{
	template: `
		<div class="province-stage">
			<slot></slot>
		</div>
	`
})

module.exports = { city, province }



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/site-lists/city.js